var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 1.91667C8.41411 1.91667 8.7499 2.25246 8.7499 2.66667V13.3333C8.7499 13.7476 8.41411 14.0833 7.9999 14.0833C7.58568 14.0833 7.2499 13.7476 7.2499 13.3333V8.75001H2.66656C2.25235 8.75001 1.91656 8.41422 1.91656 8.00001C1.91656 7.58579 2.25235 7.25001 2.66656 7.25001H7.2499V2.66667C7.2499 2.25246 7.58568 1.91667 7.9999 1.91667ZM9.24994 8.00001C9.24994 7.58579 9.58573 7.25001 9.99994 7.25001H13.3332C13.7474 7.25001 14.0832 7.58579 14.0832 8.00001C14.0832 8.41422 13.7474 8.75001 13.3332 8.75001H9.99994C9.58573 8.75001 9.24994 8.41422 9.24994 8.00001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.fe17c5f3.svg";
export { ForwardRef as ReactComponent };